import { useEffect, useRef, useState } from 'react'

const ParallaxBackground = () => {
  const [scrollY, setScrollY] = useState(0)
  const [parallaxEnabled, setParallaxEnabled] = useState(false)
  const rafId = useRef(null)

  useEffect(() => {
    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)')

    const evaluateParallaxEnabled = () => {
      setParallaxEnabled(!reducedMotionQuery.matches && window.innerWidth >= 768)
    }

    evaluateParallaxEnabled()

    window.addEventListener('resize', evaluateParallaxEnabled)
    reducedMotionQuery.addEventListener('change', evaluateParallaxEnabled)

    return () => {
      window.removeEventListener('resize', evaluateParallaxEnabled)
      reducedMotionQuery.removeEventListener('change', evaluateParallaxEnabled)
    }
  }, [])

  useEffect(() => {
    if (!parallaxEnabled) return undefined

    const handleScroll = () => {
      if (rafId.current !== null) return
      rafId.current = window.requestAnimationFrame(() => {
        setScrollY(window.scrollY)
        rafId.current = null
      })
    }

    window.addEventListener('scroll', handleScroll, { passive: true })

    return () => {
      window.removeEventListener('scroll', handleScroll)
      if (rafId.current !== null) {
        window.cancelAnimationFrame(rafId.current)
        rafId.current = null
      }
    }
  }, [parallaxEnabled])

  return (
    <>
      {/* Fixed gradient background layer (z-0) */}
      <div className="fixed inset-0 pointer-events-none z-0">
        <div className="absolute inset-0 bg-gradient-to-br from-gray-100 via-blue-50 to-blue-50" />
      </div>

      {/* Parallax logo layer - moves at 50% scroll speed for more visible effect (z-[8]) */}
      <div
        className="fixed inset-0 pointer-events-none z-[8] overflow-hidden"
        style={parallaxEnabled ? {
          transform: `translateY(calc(66.666vh + ${scrollY * -0.5}px))`,
          transition: 'transform 0.1s ease-out'
        } : undefined}
      >
        <div className="absolute inset-0 flex items-center justify-center opacity-[0.15]">
          <img
            src="/images/logo/DCon-Logo_Ball-White-Square-Trans.png"
            alt=""
            className="w-full max-w-4xl h-auto object-contain"
            aria-hidden="true"
            loading="lazy"
            width="896"
            height="896"
          />
        </div>
      </div>
    </>
  )
}

export default ParallaxBackground
